import { render, staticRenderFns } from "./coldMachineCard.vue?vue&type=template&id=ec2c560a&scoped=true&"
import script from "./coldMachineCard.vue?vue&type=script&lang=js&"
export * from "./coldMachineCard.vue?vue&type=script&lang=js&"
import style0 from "./coldMachineCard.vue?vue&type=style&index=0&id=ec2c560a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2c560a",
  null
  
)

export default component.exports